import { AxiosResponse } from 'axios'
import { HttpClient } from '@opallabs/api'

type Params = {
  assignmentId: string
  details: {
    feedback?: string
    complete?: true | false
    approved?: 'approved' | 'declined'
    reasoning?: string
  }
}

type PostResponse = (params: Params) => Promise<AxiosResponse>

export const postResponse: PostResponse = ({ assignmentId, details }) => {
  const contextAtrributes = {
    data: {
      type: 'response',
      attributes: {
        details,
      },
      relationships: {
        assignment: {
          data: {
            id: assignmentId,
            type: 'assignment',
          },
        },
      },
    },
  }

  return HttpClient().post(
    `${window.location.origin}/workflows/v2/responses?include=assignment`,
    contextAtrributes
  )
}
